import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './TermsConditions.css';

export default function TermsConditions() {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page
      }, []);
    
  return (
    <>
      <Navbar />
      <section className="TermsConditions">
        <h1>Terms and Conditions</h1>
        <p>Welcome to Sri Hari Home Care! By using our services, you agree to the following terms and conditions.</p>

        <h2>1. Introduction</h2>
        <p>These Terms and Conditions govern the use of our services provided by Sri Hari Home Care. By accessing our services, you accept these terms in full.</p>

        <h2>2. Services Offered</h2>
        <p>We provide washing machine service, AC service, and fridge service. Our team is dedicated to ensuring high-quality service and customer satisfaction.</p>

        <h2>3. User Responsibilities</h2>
        <p>Users are responsible for providing accurate information regarding their appliances and scheduling services. Ensure access to the appliance for our technicians.</p>

        <h2>4. Service Availability</h2>
        <p>Our services are available Monday to Saturday, from 9 AM to 6 PM. Service times may vary based on technician availability.</p>

        <h2>5. Pricing</h2>
        <p>All service charges will be communicated before the service is carried out. Additional costs may apply for spare parts or extra services.</p>

        <h2>6. Payments</h2>
        <p>Payments for services must be made at the time of service completion. We accept various payment methods to ensure convenience.</p>

        <h2>7. Cancellations</h2>
        <p>If you need to cancel or reschedule your service, please notify us at least 24 hours in advance to avoid any cancellation fees.</p>

        <h2>8. Warranty</h2>
        <p>We provide a warranty on the service performed. Specific warranties for spare parts will be discussed prior to service completion.</p>

        <h2>9. Limitation of Liability</h2>
        <p>We strive to deliver the best service; however, we cannot be held liable for any damages or issues resulting from improper use of appliances.</p>

        <h2>10. Customer Support</h2>
        <p>If you have any questions or concerns regarding our services, please contact our customer support team. We are here to help!</p>

        <h2>11. Modifications</h2>
        <p>We reserve the right to modify these terms at any time. Any changes will be communicated to users through our website or via email.</p>

        <h2>12. Governing Law</h2>
        <p>These terms shall be governed by and construed in accordance with the laws of the applicable jurisdiction.</p>

        <h2>13. Privacy Policy</h2>
        <p>Your privacy is important to us. Please refer to our Privacy Policy for details on how we collect, use, and protect your information.</p>

        <h2>14. Termination</h2>
        <p>We reserve the right to suspend or terminate services for any user who violates these terms or engages in unlawful behavior.</p>

        <h2>15. Contact Us</h2>
        <p>If you have any questions about these Terms and Conditions, please contact us at <a href="mailto:contact@harihomecare.com">contact@harihomecare.com</a>.</p>
      </section>
      <Footer />
    </>
  );
}
